<template>
  <div>
    <zj-layout-container>
      <zj-layout-header> </zj-layout-header>
      <zj-layout-main>
        <div class="echart">
          <div class="echart_1">
            <div>
              年客流走势
              <LineEchartsTicket
                title=""
                xAxisName=""
                yAxisName=""
                :chartData="usePerData"
              ></LineEchartsTicket>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>
<script>
import { getFlowTrend } from "@/api/src/bigData";
export default {
  action: "PassengerFlowYear",
  controller: "UI",
  name: "PassengerFlowYear",
  data() {
    return {
      usePerData: {},
      startYear: new Date().getFullYear() - 2,
      thisYear: new Date().getFullYear(),
    };
  },
  mounted: function () {
    this.search();
  },
  methods: {
    search() {
      this.usePerData = {
        xData: [],
        yData: [
          {
            name: "",
            data: [],
          },
        ],
      };
      let params = {
        polityType: 3,
        timeType: "year",
        timeValue: 1,
        district: this.CNF("app.districtCode"),
        districtCode: this.CNF("app.districtCode"),
        startTime: this.startYear + "-01-01",
        endTime: new Date(),
      };
      getFlowTrend(params).then((res) => {
        if (res.data) {
          let dataList = res.data.dataList || {};
          var XData = [];
          var yDataObj = {
            name: "",
            data: [],
          };
          for (let key in dataList) {
            if (key == this.thisYear) {
              dataList[key].map((item) => {
                const { dataTime, count } = item;
                XData.push(dataTime);
                yDataObj.data.push(count);
              });
            }
          }
          this.usePerData.yData.push(yDataObj);
          this.usePerData.xData = XData;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.datelabel {
  border-right: 3px solid #2bc5ff;
  padding: 0 1rem;
}
.echart {
  position: relative;
  width: 100%;
  height: 100%;
}
.echart_1,
.echart_2 {
  width: 100%;
  height: 48%;
}
.echart_1 {
  margin-bottom: 15px;
}
.echart_2 {
  margin-top: 15px;
}
.echart_1 > div,
.echart_2 > div {
  float: left;
  width: 50%;
  height: 100%;
  color: #2bc5ff;
  font-weight: bold;
}
</style>